<template>
  <section class="py-20 md:py-28">
    <div class="max-w-page mx-auto px-6">
      <div class="max-w-2xl mx-auto text-center">
        <span class="inline-block rounded-badge bg-secondary text-primary text-xs font-medium tracking-label uppercase px-3 py-1">
          Yapım Aşamasında
        </span>
        <h1 class="mt-6 text-4xl md:text-5xl lg:text-6xl font-medium text-primary leading-[0.95] tracking-display">
          Yatırımcı paneli<br />yolda.
        </h1>
        <p class="mt-6 text-graphite text-base md:text-lg leading-relaxed">
          Bloqin yatırımcı paneli şu anda geliştirme aşamasında. Smart kontrat denetimi ve regülasyon süreçleri tamamlandıktan sonra hizmete açılacak.
          Aşağıdan bekleme listesine katıl, gelişmelerden
          <span class="text-primary font-medium">ilk sen haberdar ol</span>.
        </p>
      </div>

      <!-- Status timeline -->
      <div class="mt-12 md:mt-16 max-w-2xl mx-auto">
        <div class="rounded-card bg-parchment border border-stone p-6 md:p-8">
          <p class="text-xs font-medium tracking-label uppercase text-graphite mb-5">Durum</p>
          <ul class="space-y-4">
            <li class="flex items-start gap-3">
              <span class="flex-shrink-0 w-6 h-6 rounded-full bg-secondary text-primary flex items-center justify-center text-xs font-medium mt-0.5">
                <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" stroke-width="3" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"/></svg>
              </span>
              <div class="flex-1">
                <p class="text-primary font-medium text-sm">Smart kontrat geliştirme</p>
                <p class="text-graphite text-sm mt-0.5">ERC-3643 standardı entegre edildi, denetim aşamasında.</p>
              </div>
            </li>
            <li class="flex items-start gap-3">
              <span class="flex-shrink-0 w-6 h-6 rounded-full bg-secondary text-primary flex items-center justify-center text-xs font-medium mt-0.5">
                <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" stroke-width="3" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"/></svg>
              </span>
              <div class="flex-1">
                <p class="text-primary font-medium text-sm">KYC/AML entegrasyonu</p>
                <p class="text-graphite text-sm mt-0.5">Kimlik doğrulama altyapısı hazır.</p>
              </div>
            </li>
            <li class="flex items-start gap-3">
              <span class="flex-shrink-0 w-6 h-6 rounded-full bg-white border-2 border-secondary text-secondary flex items-center justify-center text-xs font-medium mt-0.5">
                <span class="w-2 h-2 rounded-full bg-secondary animate-pulse"></span>
              </span>
              <div class="flex-1">
                <p class="text-primary font-medium text-sm">Yatırımcı paneli arayüzü</p>
                <p class="text-graphite text-sm mt-0.5">Şu anda aktif geliştirme. Tasarım ve frontend implementasyonu sürüyor.</p>
              </div>
            </li>
            <li class="flex items-start gap-3">
              <span class="flex-shrink-0 w-6 h-6 rounded-full bg-white border border-stone flex items-center justify-center text-xs font-medium mt-0.5">
              </span>
              <div class="flex-1">
                <p class="text-graphite font-medium text-sm">Regülasyon &amp; denetim</p>
                <p class="text-graphite text-sm mt-0.5">İlgili regülasyon süreçleri ve bağımsız smart kontrat denetimi tamamlandığında platform lansmana hazır olacak.</p>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <!-- Waitlist embed -->
      <div class="mt-12 md:mt-16">
        <WaitListForm />
      </div>

      <!-- Back link -->
      <div class="mt-10 text-center">
        <router-link
          to="/"
          class="inline-flex items-center text-primary text-sm font-medium hover:text-secondary transition-colors"
        >
          <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M10 19l-7-7m0 0l7-7m-7 7h18"/></svg>
          Ana sayfaya dön
        </router-link>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import WaitListForm from '@/components/WaitListForm.vue';

export default defineComponent({
  name: 'LoginView',
  components: {
    WaitListForm,
  },
});
</script>
